import _slicedToArray from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _createForOfIteratorHelper from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _asyncToGenerator from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.number.to-fixed.js";
import * as echarts from 'echarts';
import dayjs from 'dayjs';
import dailyReport from './components/dailyReport';
var proposal = {
  "制氧机建议开启时间": ["00:00–24:00（储气罐容量满时自动停止）"],
  "循环水泵建议开启时间": ["00:00–8:00", "12:00-18:00"],
  "微滤机建议开启时间": ["00:00–00:30", "01:25–01:55", "02:50–03:20", "04:15–04:45", "05:40–06:10", "07:05–07:35", "08:30–09:00", "09:55–10:25", "11:20–11:50", "12:45–13:15", "14:10–14:40", "15:35–16:05", "17:00–17:30", "18:25–18:55", "19:50–20:20", "21:15–21:45", "22:40–23:10"],
  "悬浮风机建议开启时间": ["00:00–02:00", "06:00–07:00", "08:00–10:00", "15:00–17:00", "22:00–24:00"],
  "污水泵建议开启时间": ["00:00–01:00", "06:00–07:00", "15:00–16:00", "23:00–24:00"],
  "溶氧锥建议开启时间": ["00:00–00:30", "00:45–01:00", "01:15–01:45", "02:00–02:15", "02:30–02:45", "03:00–03:15", "03:30–04:00", "04:15–04:30", "04:45–05:00", "05:15–05:30", "05:45–06:00", "06:15–06:45", "07:00–07:15", "07:30–07:45", "08:00–08:15", "08:30–08:45", "09:00–09:15", "09:30–09:45", "10:00–10:15", "10:30–10:45", "11:00–11:30", "11:45–12:00", "12:15–12:30", "12:45–13:00", "13:15–13:30", "13:45–14:00", "14:15–14:30", "14:45–15:15", "15:30–15:45", "16:00–16:15", "16:30–16:45", "17:00–17:15", "17:30–18:00", "18:15–18:30", "18:45–19:00", "19:15–19:30", "19:45–20:15", "20:30–20:45", "21:00–21:15", "21:30–22:00", "22:15–22:30", "22:45–23:00", "23:15–23:45"],
  "紫外线杀菌灯建议开启时间": ["00:00–4:00", "10:00-14:00", "18:00-20:00"]
};
export default {
  components: {
    dailyReport: dailyReport
  },
  data: function data() {
    return {
      dayjs: dayjs,
      device_list: [],
      deviceId: '',
      overview_data: {},
      proposal: proposal,
      totalData: {}
    };
  },
  mounted: function mounted() {
    this.getTotal();
    this.getDevice();
    this.getDayReport();
    this.getMonthReport();
  },
  destroyed: function destroyed() {
    if (this.myChart1) {
      this.myChart1.dispose();
    }
    if (this.myChart2) {
      this.myChart2.dispose();
    }
  },
  methods: {
    backClick: function backClick() {
      this.$router.back();
    },
    getTotal: function getTotal() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, yesterday, before, lastmonth, beforemonth, lastyear, beforeyear, days, months, years, _iterator, _step, item, _iterator2, _step2, _item, _iterator3, _step3, _item2;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$api['monitorReport'](localStorage.getItem('labId'), 'Total');
            case 2:
              res = _context.sent;
              _this.totalData = res.data;
              _this.$set(_this.totalData, 'today', '--');
              _this.$set(_this.totalData, 'todayRate', '--');
              _this.$set(_this.totalData, 'month', '--');
              _this.$set(_this.totalData, 'monthRate', '--');
              _this.$set(_this.totalData, 'year', '--');
              _this.$set(_this.totalData, 'yearRate', '--');
              yesterday = dayjs().subtract(1, 'day').format('YYYY-MM-DD');
              before = dayjs().subtract(2, 'day').format('YYYY-MM-DD');
              lastmonth = dayjs().subtract(1, 'month').format('YYYY-MM');
              beforemonth = dayjs().subtract(2, 'month').format('YYYY-MM');
              lastyear = dayjs().subtract(1, 'year').format('YYYY');
              beforeyear = dayjs().subtract(2, 'year').format('YYYY');
              days = {}, months = {}, years = {};
              _iterator = _createForOfIteratorHelper(res.data.Days || []);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  item = _step.value;
                  days[dayjs(item.ts).format('YYYY-MM-DD')] = item.indicator;
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              _iterator2 = _createForOfIteratorHelper(res.data.Months || []);
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  _item = _step2.value;
                  months[dayjs(_item.ts).format('YYYY-MM')] = _item.indicator;
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              _iterator3 = _createForOfIteratorHelper(res.data.Years || []);
              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  _item2 = _step3.value;
                  years[dayjs(_item2.ts).format('YYYY')] = _item2.indicator;
                }
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
              if (days[yesterday]) {
                _this.$set(_this.totalData, 'today', (res.data.Current - days[yesterday]).toFixed(2));
                if (days[before]) {
                  _this.$set(_this.totalData, 'todayRate', (res.data.Current - days[yesterday] - (days[yesterday] - days[before]) / (days[yesterday] - days[before]) * 100).toFixed(2));
                }
              }
              if (months[lastmonth]) {
                _this.$set(_this.totalData, 'month', (res.data.Current - months[lastmonth]).toFixed(2));
                if (days[beforemonth]) {
                  _this.$set(_this.totalData, 'monthRate', (res.data.Current - months[lastmonth] - (months[lastmonth] - months[beforemonth]) / (months[lastmonth] - months[beforemonth]) * 100).toFixed(2));
                }
              }
              if (years[lastyear]) {
                _this.$set(_this.totalData, 'year', (res.data.Current - years[lastyear]).toFixed(2));
                if (days[beforeyear]) {
                  _this.$set(_this.totalData, 'yearRate', (res.data.Current - years[lastyear] - (years[lastyear] - years[beforeyear]) / (years[lastyear] - years[beforeyear]) * 100).toFixed(2));
                }
              }
            case 26:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    getDevice: function getDevice() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _res$data$;
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.$api['monitorQueryJoinPower']({
                page: 1,
                limit: 10,
                labId: localStorage.getItem('labId'),
                meterType: 'Sub'
              });
            case 2:
              res = _context2.sent;
              _this2.device_list = res.data || [];
              _this2.deviceId = (_res$data$ = res.data[0]) === null || _res$data$ === void 0 ? void 0 : _res$data$.id;
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getDayReport: function getDayReport() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res, xAxisData, seriesData, _ref, _ref2, init, _iterator4, _step4, item, option;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this3.$api['monitorReportModel'](localStorage.getItem('labId'), 'Total', 'Day', {
                startDate: "".concat(dayjs().subtract(30, 'day').format('YYYY-MM-DD')),
                endDate: "".concat(dayjs().format('YYYY-MM-DD'))
              });
            case 2:
              res = _context3.sent;
              xAxisData = [], seriesData = [];
              res.data.reverse();
              _ref = res.data.length > 1 ? res.data.splice(0, 1) : [{
                indicator: 0
              }], _ref2 = _slicedToArray(_ref, 1), init = _ref2[0];
              _iterator4 = _createForOfIteratorHelper(res.data);
              try {
                for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                  item = _step4.value;
                  xAxisData.push(dayjs(item.ts).format('YYYY-MM-DD'));
                  seriesData.push((item.indicator * 100 - init.indicator * 100).toFixed(0) / 100);
                  init = item;
                }
              } catch (err) {
                _iterator4.e(err);
              } finally {
                _iterator4.f();
              }
              _this3.echart1 = echarts.init(document.getElementById('daily-trend-line'));
              option = {
                backgroundColor: 'transparent',
                title: {
                  text: '用电量',
                  left: 10,
                  top: 10,
                  textStyle: {
                    color: '#fff',
                    fontSize: 14
                  }
                },
                tooltip: {
                  trigger: 'axis'
                },
                grid: {
                  left: '3%',
                  right: '4%',
                  bottom: '3%',
                  containLabel: true
                },
                xAxis: {
                  type: 'category',
                  boundaryGap: false,
                  data: xAxisData,
                  axisLine: {
                    lineStyle: {
                      color: '#6078a3'
                    }
                  },
                  axisLabel: {
                    color: '#b0c4de',
                    fontSize: 14
                  },
                  splitLine: {
                    show: false
                  }
                },
                yAxis: {
                  type: 'value',
                  min: 0,
                  axisLine: {
                    show: false
                  },
                  axisTick: {
                    show: false
                  },
                  axisLabel: {
                    color: '#b0c4de',
                    fontSize: 14
                  },
                  splitLine: {
                    lineStyle: {
                      color: '#30476b',
                      type: 'solid'
                    }
                  }
                },
                series: [{
                  name: '用电量',
                  type: 'line',
                  smooth: true,
                  symbol: 'none',
                  lineStyle: {
                    width: 4,
                    color: '#48e5e5'
                  },
                  data: seriesData
                }]
              };
              _this3.echart1.setOption(option);
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    getMonthReport: function getMonthReport() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var res, xAxisData, seriesData, _ref3, _ref4, init, _iterator5, _step5, item, option;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this4.$api['monitorReportModel'](localStorage.getItem('labId'), 'Total', 'Month', {
                startDate: "".concat(dayjs().format('YYYY'), "-01-01"),
                endDate: "".concat(dayjs().format('YYYY'), "-12-31")
              });
            case 2:
              res = _context4.sent;
              xAxisData = [], seriesData = [];
              res.data.reverse();
              _ref3 = res.data.length > 1 ? res.data.splice(0, 1) : [{
                indicator: 0
              }], _ref4 = _slicedToArray(_ref3, 1), init = _ref4[0];
              _iterator5 = _createForOfIteratorHelper(res.data);
              try {
                for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                  item = _step5.value;
                  xAxisData.push("".concat(dayjs(item.ts).format('MM'), "\u6708"));
                  seriesData.push((item.indicator * 100 - init.indicator * 100).toFixed(0) / 100);
                }
              } catch (err) {
                _iterator5.e(err);
              } finally {
                _iterator5.f();
              }
              _this4.echart1 = echarts.init(document.getElementById('equipment-trend-line'));
              option = {
                backgroundColor: 'transparent',
                title: {
                  text: '用电量',
                  left: 10,
                  top: 10,
                  textStyle: {
                    color: '#fff',
                    fontSize: 14
                  }
                },
                tooltip: {
                  trigger: 'axis'
                },
                grid: {
                  left: '3%',
                  right: '4%',
                  bottom: '3%',
                  containLabel: true
                },
                xAxis: {
                  type: 'category',
                  boundaryGap: false,
                  data: xAxisData,
                  axisLine: {
                    lineStyle: {
                      color: '#6078a3'
                    }
                  },
                  axisLabel: {
                    color: '#b0c4de',
                    fontSize: 14
                  },
                  splitLine: {
                    show: false
                  }
                },
                yAxis: {
                  type: 'value',
                  min: 0,
                  axisLine: {
                    show: false
                  },
                  axisTick: {
                    show: false
                  },
                  axisLabel: {
                    color: '#b0c4de',
                    fontSize: 14
                  },
                  splitLine: {
                    lineStyle: {
                      color: '#30476b',
                      type: 'solid'
                    }
                  }
                },
                series: [{
                  name: '用电量',
                  type: 'line',
                  smooth: true,
                  symbol: 'none',
                  lineStyle: {
                    width: 4,
                    color: '#48e5e5'
                  },
                  data: seriesData
                }]
              };
              _this4.echart1.setOption(option);
            case 11:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    }
  }
};